/**
 * 筛选
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/3/21      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


import React from 'react'
import PropTypes from "prop-types";
import {Button,Input,DatePicker,Select,Form,Row,Col,InputNumber,Checkbox} from 'antd';
import "./index.less";
import Category from "../Category";
import UploadFile from '../../../fuzzy-detail/components/Contact/components/UploadFile/index';
import ImgScreen from "../ImgScreen";
const { RangePicker } = DatePicker;
const {Option} = Select;

class Screen extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            prdGoodsCopyrightSources:__getDictList("prd_goods_copyright")||[],
            supCertificationSources:__getDictList("sup_certification_type")||[],
            pkgSource:[],
            imageFileList:[]
        }
    }

    bindRef = React.createRef();

    /**
     * 提交
     **/
    submit(){
        const { validateFields } = this.bindRef.current;
        validateFields().then((values)=>{
            let postData = {};
            for (var i in values){
                if(values[i]!==undefined){
                    if(['priceBaseStart','priceBaseEnd','purchaseMoqStart','purchaseMoqEnd','deliverDayStart','deliverDayEnd'].indexOf(i)!=-1){
                        postData[i] = Number(values[i]);

                    }else{
                        postData[i] = values[i];
                    }
                }
            }
            //处理筛选项
            if(postData.keyword){
                postData[postData.type] = postData.keyword;
            }
            delete postData.type;
            delete postData.keyword;

            if(postData.firOnSellTime){
                postData.firOnSellTimeStart = postData.firOnSellTime[0]?postData.firOnSellTime[0].format("X"):null;
                postData.firOnSellTimeEnd = postData.firOnSellTime[1]?postData.firOnSellTime[1].format("X"):null;
                delete postData.firOnSellTime;
            }

            if(postData.goodType){
                postData.goodType = 1;
            }else{
                delete postData.goodType;
            }

            let imageFileList = this.state.imageFileList||[];
            if(imageFileList.length>0){
                postData.imageSearchCondition = {
                    crop:true,
                    imageFileId:imageFileList[imageFileList.length-1].fileId
                }
                if(this.state.region){
                    postData.imageSearchCondition.region = this.state.region;
                }
            }

            this.props.handleChange(1,postData);
        })
    }

    /**
     * 重置
     **/
    reset(){
        // this.props.form.resetFields();
        const { resetFields } = this.bindRef.current;
        resetFields();
        this.props.handleChange(1, {});
    }

    onChangeImg(state){
        this.setState(state,()=>{
            this.submit();
        });
    }

    getPackSource(){
        $.ajax({
            url: "/service/mg/goods/attribute-option-list",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify({
                code:'PKG'
            }),
            success:(res)=>{
                if(res.success&&res.valid){
                    this.setState({
                        pkgSource:((res.model&&res.model.option)||[]).map(function (item) {
                            item.code = item.value;
                            return item;
                        })
                    })
                }
            }
        });
    }

    changeUploadFile(imgList){
        let item = null;
        if(imgList.length>0){
            item = imgList[imgList.length-1];
        }
        this.setState({
            imageFileList:item?[item]:[],
        },()=>{
            this.submit();
        })
    }

    componentDidMount() {
        this.getPackSource();
    }

    render(){
        let state = this.state;
        let col = {
            labelCol:{span:9},
            wrapperCol:{span:15}
        }
        const prefixSelector = <Form.Item name='type' style={{height:'30px'}} initialValue={'no'}>
            <Select style={{ width: 70 }}>
                <Option value="no">{__getServerLanguage('BianHao')}</Option>
                <Option value="factoryNo">{__getServerLanguage('HuoHao')}</Option>
            </Select>
        </Form.Item>;

        return (
            <div>
                <div className="mt_20">
                    <div className="recommend-list__screen">
                        <div className="screen-wrap">
                            <Form ref={this.bindRef}
                                  className="screen-content-wrap"
                                  layout={'horizontal'}>
                                <Row gutter={16}>
                                    <Col span={6}>
                                        <Category col={col}></Category>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item {...col}
                                                   colon={false}
                                                   name='supplierKeyword'
                                                   label={__getServerLanguage('PinPai/GongYingShang')}>
                                            <Input></Input>
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item name="keyword" colon={false}>
                                            <Input addonBefore={prefixSelector}></Input>
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item {...col} name="name" colon={false} label={__getServerLanguage('PinMing')}>
                                            <Input></Input>
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item {...col} name="certiTypeCodes" colon={false} label={__getServerLanguage('ZhengShu')}>
                                            <Select getPopupContainer={triggerNode => triggerNode.parentNode}
                                                    showArrow={true}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    mode='multiple'
                                                    maxTagCount={1}
                                            >
                                                {state.supCertificationSources.map(function (item, index) {
                                                    return <Select.Option value={item.code} key={index}>{item.name}</Select.Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item  {...col} name="packageValues" colon={false} label={__getServerLanguage('BaoZhuangLeiXing')}>
                                            <Select getPopupContainer={triggerNode => triggerNode.parentNode}
                                                    showArrow={true}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    mode='multiple'
                                                    maxTagCount={1}
                                            >
                                                {state.pkgSource.map(function (item, index) {
                                                    return <Select.Option value={item.code} key={index}>{item.name}</Select.Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Col>


                                    <Col span={6}>
                                        <Form.Item  {...col} name="copyrightItemCodes" colon={false}
                                                    label={__getServerLanguage('ShangPinBanQuan')}>
                                            <Select getPopupContainer={triggerNode => triggerNode.parentNode}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    showArrow={true}
                                                    mode='multiple'
                                                    maxTagCount={1}
                                            >
                                                {state.prdGoodsCopyrightSources.map(function (item, index) {
                                                    return <Select.Option value={item.code} key={index}>{item.name}</Select.Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Col>


                                    <Col span={6}>
                                        <Form.Item  {...col} name="firOnSellTime" colon={false} label={__getServerLanguage('ShangShiShiJian')}>
                                            <RangePicker getCalendarContainer={triggerNode => triggerNode.parentNode}
                                                         placeholder={[__getServerLanguage('KaiShiShiJian'),__getServerLanguage('JieShuShiJian')]}></RangePicker>
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item {...col} className="item" colon={false} label={__getServerLanguage('JiaGe')}>
                                            <div className="dropdown-input-box mr_10"
                                                 data-flex="cross:center">
                                                <Form.Item name="priceBaseStart">
                                                    <InputNumber min={0.001} precision={3} type="number" placeholder="min"></InputNumber>
                                                </Form.Item>
                                                <p className="input-line"></p>
                                                <Form.Item name="priceBaseEnd">
                                                    <InputNumber min={0.001} precision={3} type="number" placeholder="max"></InputNumber>
                                                </Form.Item>
                                            </div>
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item {...col} className="item" colon={false} label={__getServerLanguage('HuoQi')}>
                                            <div className="dropdown-input-box mr_10">
                                                <Form.Item data-flex="cross:center" name="deliverDayStart" className="margin-bottom-0">
                                                    <InputNumber min={0} precision={0} type="number" placeholder="min"></InputNumber>
                                                </Form.Item>


                                                <p className="input-line" data-flex="cross:center"></p>
                                                <Form.Item data-flex="cross:center" name="deliverDayEnd" className="margin-bottom-0">
                                                    <InputNumber min={0} precision={0} type="number" placeholder="max"></InputNumber>
                                                </Form.Item>
                                            </div>
                                        </Form.Item>
                                    </Col>

                                    <Col span={6}>
                                        <Form.Item {...col} className="item" colon={false} label="MOQ">
                                            <div className="dropdown-input-box mr_10"
                                                 data-flex="cross:center">
                                                <Form.Item name="purchaseMoqStart">
                                                    <InputNumber min={0} precision={0} type="number" placeholder="min"></InputNumber>
                                                </Form.Item>
                                                <p className="input-line"></p>
                                                <Form.Item name="purchaseMoqEnd">
                                                    <InputNumber min={0} precision={0} type="number" placeholder="max"></InputNumber>
                                                </Form.Item>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <div className="flex-box" data-flex="main:center">
                                    <Button type="primary" onClick={this.submit.bind(this)}>{__getServerLanguage('SouSuo')}</Button>
                                    <UploadFile fileSizeLimit={4194304} onChange={this.changeUploadFile.bind(this)}>
                                        <Button className="btn-little-blue ml_8">{__getServerLanguage('YiTuSouSuo')}</Button>
                                    </UploadFile>
                                    <Button className="ml_8" onClick={this.reset.bind(this)}>{__getServerLanguage('ZhongZhi')}</Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
                {
                    this.props.imageFileUrl?
                        <div className="mt_20">
                            <ImgScreen {...this.props} region={this.state.region} imageFileList={this.state.imageFileList} onChangeImg={this.onChangeImg.bind(this)}></ImgScreen>
                        </div>
                        :
                        null
                }

            </div>

        )
    }
}

Screen.defaultProps = {
    handleChange:function () {

    }

}

Screen.propTypes = {

}
// export default Form.create({})(Screen);
export default Screen;
